import { Combobox, Input, InputBase, useCombobox } from "@mantine/core";
import IconProUpgrade from "@src/assets/icons/pro-badge.svg?react";
import { useMyPlanSuspense } from "@src/components/plan/queries/fetch-plan";
import { PlanFamily } from "@src/gql/graphql";
import clsx from "clsx";

export type PermissionType = "can view" | "can edit";

interface PermissionComboboxProps {
	value: PermissionType;
	onChange: (value: PermissionType) => void;
	disabled?: boolean;
}

export function PermissionCombobox(props: PermissionComboboxProps) {
	const { value, onChange, disabled } = props;
	const { data: plan } = useMyPlanSuspense();

	const combobox = useCombobox({
		onDropdownClose: () => combobox.resetSelectedOption(),
	});

	const options: PermissionType[] = ["can view", "can edit"];
	const isStarter = plan.planFamily === PlanFamily.Starter;

	const comboboxOptions = options.map((item) => {
		if (item === "can edit" && isStarter) {
			return (
				<div key={item} className="flex flex-row justify-between items-center">
					<Combobox.Option
						key={item}
						value={item}
						disabled={true}
						classNames={{
							option: "mr-0",
						}}
					>
						{item}
					</Combobox.Option>
					<IconProUpgrade height={24} className="mr-1" />
				</div>
			);
		}
		return (
			<Combobox.Option key={item} value={item} disabled={disabled}>
				{item}
			</Combobox.Option>
		);
	});

	return (
		<Combobox
			zIndex={3700}
			store={combobox}
			onOptionSubmit={(val) => {
				const permission = val as PermissionType;
				combobox.closeDropdown();
				onChange(permission);
			}}
		>
			<Combobox.Target>
				<InputBase
					value={value}
					component="button"
					type="button"
					pointer
					rightSection={<Combobox.Chevron />}
					rightSectionPointerEvents="none"
					onClick={() => combobox.toggleDropdown()}
					disabled={disabled}
					classNames={{ input: "focus:border-brand-primary" }}
					className={clsx(
						disabled && "[&_button]:text-text-primary/30",
						isStarter && "min-w-32.5",
					)}
				>
					{value ?? <Input.Placeholder>Select permission</Input.Placeholder>}
				</InputBase>
			</Combobox.Target>

			<Combobox.Dropdown>
				<Combobox.Options>{comboboxOptions}</Combobox.Options>
			</Combobox.Dropdown>
		</Combobox>
	);
}
